export default __webpack_public_path__ + "static/media/Edit.44ad1052.svg";